import { useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import Switch from 'react-switch';
import { sidebarOpenState, useRecoilValue } from 'store';
import styled from 'styled-components';
import cn from 'classnames';
import { Props, ShareMethod } from './types';
import { copyToClipboard, getBaseURL } from '@/components/util';
import { TourType } from '@/_models/Tour';

export default function Share(props: Props) {
  const {
    onClose,
    translation = {},
    onColor,
    tour,
    link,
    getLocation = () => undefined,
    closeOnOutsideClick,
    tourType,
  } = props;
  const [shareLocation, setShareLocation] = useState(false);
  const sbIsOpen = useRecoilValue(sidebarOpenState);
  const ref = useRef({ cancelClose: true });

  const handleShareLocation = async (checked: any) => {
    setShareLocation(checked);
  };

  const share = async (selectedShareMethod: ShareMethod) => {
    let linkValue = link || getBaseURL();

    if (shareLocation) linkValue = getLocation();
    if (selectedShareMethod === ShareMethod.Facebook) {
      const fbAppId = tour?.client?.fbAppId || tour?.user?.fbAppId;
      window.open(
        `https://www.facebook.com/dialog/share?app_id=${fbAppId || '741048509750318'}&display=popup&href=${encodeURIComponent(linkValue)}&redirect_uri=${encodeURIComponent(
          linkValue,
        )}`,
        '_blank',
      );
    }
    if (selectedShareMethod === ShareMethod.Whatsapp) {
      window.open(`https://wa.me/?text=${encodeURIComponent(linkValue)}`, '_blank');
    }
    if (selectedShareMethod === ShareMethod.Mail) {
      window.open(`mailto:?body=${encodeURIComponent(linkValue)}`, '_blank');
    }
    if (selectedShareMethod === ShareMethod.Twitter) {
      window.open(
        `https://twitter.com/intent/tweet?text=${encodeURIComponent(linkValue)}`,
        '_blank',
      );
    }
    if (selectedShareMethod === ShareMethod.Clipboard) {
      const segmants = window.location.href.split('/');
      const slug = segmants[segmants.length - 1].split('?')[0];
      if (tour.slug !== slug) {
        const params = linkValue.split('?')[1];

        linkValue = shareLocation
          ? `${linkValue
              .split('/')
              .map((part, index) => (index === 4 ? tour.slug : part))
              .join('/')}${params ? `?${params}` : ''}`
          : linkValue
              .split('/')
              .map((part, index, arr) => (index === arr.length - 1 ? tour.slug : part))
              .join('/');
      }
      copyToClipboard(linkValue);
      toast.success('Copied to clipboard');
    }

    onClose();
  };

  const handleOutsideClick = () => {
    if (!ref.current.cancelClose) {
      onClose();
    } else {
      ref.current.cancelClose = false;
    }
  };
  const handleInsideClick = () => {
    ref.current.cancelClose = true;
  };

  useEffect(() => {
    if (closeOnOutsideClick) {
      document.addEventListener('click', handleOutsideClick);
      return () => document.removeEventListener('click', handleOutsideClick);
    }
  }, []);

  const MainWrap = styled.div<{ sbIsOpen?: boolean }>`
    &.eCommerce {
      top: '100px';
      margin-top: 0;
      right: ${({ sbIsOpen }) => (sbIsOpen ? '180px' : '50px')};
      .switchLabel {
        max-width: 100px;
      }
      @media screen and (max-width: 480px) {
        top: 'initial';
        right: 'initial';
        .switchLabel {
          max-width: initial;
        }
      }
    }
  `;

  return (
    <MainWrap
      sbIsOpen={sbIsOpen}
      className={cn('popup', tourType === TourType.ECommerce && 'eCommerce')}
      id="share-pop"
      onClick={handleInsideClick}
    >
      <h3>{translation?.shareTooltip || 'Share'}</h3>
      <button className="close" onClick={onClose}>
        <i className="fas fa-times" />
      </button>

      <button onClick={() => share(ShareMethod.Facebook)}>
        <i className="fab fa-facebook icon" />
      </button>

      <button onClick={() => share(ShareMethod.Twitter)}>
        <i className="fab fa-twitter icon" />
      </button>

      <button onClick={() => share(ShareMethod.Whatsapp)}>
        <i className="fab fa-whatsapp icon" />
      </button>

      <button onClick={() => share(ShareMethod.Mail)}>
        <i className="fas fa-envelope icon" />
      </button>

      <button onClick={() => share(ShareMethod.Clipboard)}>
        <i className="fas fa-link icon" />
      </button>

      {!props.hideShareLocation && (
        <label htmlFor="share-location-switch" className="switchLabel">
          {translation?.shareLocation || 'Location'}
          <Switch
            id="share-location-switch"
            onColor={onColor}
            onChange={handleShareLocation}
            checked={shareLocation}
          />
        </label>
      )}
    </MainWrap>
  );
}
